var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      _c("el-checkbox", {
        model: {
          value: _vm.item.isCheck,
          callback: function ($$v) {
            _vm.$set(_vm.item, "isCheck", $$v)
          },
          expression: "item.isCheck",
        },
      }),
      _c(
        "el-image",
        {
          staticStyle: { width: "100px", "margin-left": "0.1rem" },
          attrs: { src: _vm.item.imageUrl, "preview-src-list": _vm.srcList },
        },
        [
          _c(
            "div",
            {
              staticClass: "image-slot",
              attrs: { slot: "error" },
              slot: "error",
            },
            [_vm._v("暂无图片")]
          ),
        ]
      ),
      _c("div", { staticStyle: { "margin-left": "0.1rem", width: "4rem" } }, [
        _c("p", [_vm._v(_vm._s(_vm.item.resourceName))]),
        _c("p", [_vm._v(_vm._s(_vm.item.word))]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }